import { createContext, useState } from 'react'

import type { IInputCreditCardProps } from '../types'

export interface InputCreditCardPropsProviderProps
  extends IInputCreditCardProps {
  children: React.ReactNode
  value: string
}

export interface InputCreditCardContextProps
  extends Omit<IInputCreditCardProps, 'children'> {
  isActive: boolean
  setIsActive: (value: boolean) => void
  inputValue: string
  isFilled: boolean
}

export const InputCreditCardContext =
  createContext<InputCreditCardContextProps>({
    isActive: false,
    setIsActive: (value: boolean) => {},
    inputValue: '',
    isFilled: false,
    errorText: '',
  })

const { Provider } = InputCreditCardContext

export function InputCreditCardProvider({
  children,
  value,
  ...props
}: InputCreditCardPropsProviderProps) {
  const [isActive, setIsActive] = useState(false)

  const customProps = {
    ...props,
    isActive,
    setIsActive,
    inputValue: value,
    isFilled: value.length > 0,
  }
  return <Provider value={{ ...customProps }}>{children}</Provider>
}
